import { isEmpty, cloneDeep } from '@/helpers/utilities';

export default {
  isMaxPage: (state) => state.currentPage >= state.maxPages || state.maxPages === 0,
  // get finance defaults and convert to int
  financeDefaults: (state) => {
    // !TODO update to be dynamic based on search condition
    const {
      payment,
      annualMileage,
      term,
      deposit,
      depositType,
      product,
    } = state.context.site.stockScope.usedFinanceDefaults;

    const result = {
      payment,
      depositType,
      annualMileage: Number(annualMileage),
      deposit: Number(deposit),
      term: Number(term),
    };

    if (product) {
      result.product = product;
    }

    return result;
  },
  newFinanceDefaults: (state) => {
    // !TODO update to be dynamic based on search condition
    const { newFinanceDefaults } = state.context.site.stockScope;
    let newFinanceDefaultsValue = cloneDeep(newFinanceDefaults);

    if (isEmpty(newFinanceDefaults)) return [];
    if (!Array.isArray(newFinanceDefaults)) {
      newFinanceDefaultsValue = [{ ...newFinanceDefaults }];
    }

    return newFinanceDefaultsValue.reduce((result, financeItemContext) => {
      if (isEmpty(financeItemContext)) return result;

      const {
        payment,
        annualMileage,
        term,
        deposit,
        depositType,
        product,
        conditionValue,
      } = financeItemContext;

      if (!annualMileage && !term && !deposit) return result;

      result.push({
        payment,
        depositType,
        product,
        conditionValue,
        annualMileage: Number(annualMileage),
        deposit: Number(deposit),
        term: Number(term),
      });

      return result;
    }, []);
  },
  uuid: (state) => {
    const { uuid } = state.context.site.gfSearchApi;
    if (uuid) return uuid;
    return process.env.NODE_ENV === 'development' ? 'b03ab890-5fc0-11eb-8723-bf1709c848d3' : ''; // for testing 28448b00-98d8-11ea-af0c-4194762b51bc
  },
  clientToken: (state) => {
    const { clientToken } = state.context.site.gfSearchApi;
    if (clientToken) return clientToken;
    return process.env.NODE_ENV === 'development' ? '3e826840-5fc2-11eb-94bf-77637b708bd3' : ''; // for testing 28448b00-98d8-11ea-af0c-4194762b51bc
  },
  apiUrl: (state) => {
    const { apiUrl } = state.context.site.gfSearchApi;
    if (apiUrl) return apiUrl;
    return process.env.NODE_ENV === 'development'
      ? 'https://production-api.search-api.netdirector.auto'
      : '';
  },
  /**
   * get searchCriteria based on all the search values within the context and customer input
   * @return object containing search params
   */
  searchCriteria: (state, getters) => {
    const result = {
      ...getters.getStockScope,
      ...getters.getSiteScope,
      ...getters.getSectionScope,
      ...state.searchCriteria,
    };

    Object.entries(result).forEach(([key, value]) => {
      if (Array.isArray(value) && value.length === 1 && value[0] === 'All') {
        delete result[key];
      }
    });

    return result;
  },
  /**
   * get defaultScope based on the stock scope and the current site scope
   * @return object containing search params
   */
  getDefaultScope: (state, getters) => ({
    ...getters.getStockScope,
    ...getters.getSiteScope,
    ...getters.getSectionScope,
  }),
  getSiteScope: (state) => {
    const { stockScope } = state.context.site;
    if (!stockScope || Object.keys(stockScope).length === 0) return {};
    const { siteCustomQuery } = stockScope;
    if (!siteCustomQuery || siteCustomQuery.length === 0) return {};
    return siteCustomQuery;
  },
  getSectionScope: (state) => {
    const { stockScope } = state.context.site;
    if (!stockScope || Object.keys(stockScope).length === 0) return {};
    const { sectionCustomQuery } = stockScope;
    if (!sectionCustomQuery || sectionCustomQuery.length === 0) return {};
    return sectionCustomQuery;
  },
  getStockScope: (state) => {
    // stock scope logic to be used from V10
    const { stockScope } = state.context.site;
    if (!stockScope || Object.keys(stockScope).length === 0) return {};
    // we dont need to use the stock scope if its set to endpoint
    if (!stockScope.type || stockScope.type === 'endpoint') return {};
    return {
      [stockScope.type]: stockScope.values,
    };
  },
};
